module.exports = __webpack_public_path__ + "static/media/pep.ef0af284.svg";